var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2422 13.4156C39.5469 13.1977 40 13.4016 40 13.7461V28.125C40 29.9883 38.3203 31.5 36.25 31.5H3.75C1.67969 31.5 0 29.9883 0 28.125V13.7531C0 13.4016 0.445312 13.2047 0.757812 13.4227C2.50781 14.6461 4.82812 16.2 12.7969 21.4102C14.4453 22.493 17.2266 24.7711 20 24.757C22.7891 24.7781 25.625 22.4508 27.2109 21.4102C35.1797 16.2 37.4922 14.6391 39.2422 13.4156ZM20 22.5C21.8125 22.5281 24.4219 20.4469 25.7344 19.5891C36.1016 12.818 36.8906 12.2273 39.2812 10.5398C39.7344 10.2234 40 9.73125 40 9.21094V7.875C40 6.01172 38.3203 4.5 36.25 4.5H3.75C1.67969 4.5 0 6.01172 0 7.875V9.21094C0 9.73125 0.265625 10.2164 0.71875 10.5398C3.10938 12.2203 3.89844 12.818 14.2656 19.5891C15.5781 20.4469 18.1875 22.5281 20 22.5Z",
    fill: "#EAB9F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.125125ef2e603d036f50c530e9340b5d.svg";
export { ForwardRef as ReactComponent };